import React from 'react';
import CachedIcon from '@mui/icons-material/Cached';

export default function RotatingSpinner({ className = '', style = {}, iconProps = {} }) {
  return (
    <CachedIcon
      data-testid="RotateRightIcon"
      className={className + ' tw:transform tw:scale-x-[-1] spin spin-left'}
      style={style}
      {...iconProps}
    />
  );
}
